<template>
  <footer>
    <div class="footer">
      <div class="container">
        <div class="footer-main">
          <div class="footer-main__left">
            <div class="footer-main__logo">
              <img src="@/assets/images/logo_light.png" alt="logo" />
            </div>
          </div>

          <div class="footer-main__right">
            <div class="footer-social">
              <a class="footer-social__item" href="https://www.facebook.com/profile.php?id=61566279313684" target="_blank">
                <img src="@/assets/images/system/footer_icon_facebook.svg" alt="Facebook">
              </a>
              <a class="footer-social__item" href="https://lin.ee/D0YDuxI" target="_blank">
                <img src="@/assets/images/system/footer_icon_line.svg" alt="Line">
              </a>
              <a class="footer-social__item" href="https://www.youtube.com/@%E6%88%90%E5%9D%87%E5%AD%B8%E9%99%A2/videos" target="_blank">
                <img src="@/assets/images/system/footer_icon_youtube.svg" alt="Youtube">
              </a>
              <a class="footer-social__item" href="https://www.instagram.com/cjuni.teaching" target="_blank">
                <img src="@/assets/images/system/footer_icon_instagram.svg" alt="Instagram">
              </a>
              <a class="footer-social__item" href="https://cjuni20240801.pixnet.net/blog" target="_blank">
                <img src="@/assets/images/system/footer_icon_pixnet.svg" alt="Pixnet">
              </a>
            </div>

            <div class="footer-menu">
              <div
                v-for="item in menuList"
                :key="item.title"
                class="footer-menu__box"
              >
                <div v-if="item.title" class="footer-menu__title">
                  <router-link
                    v-if="item.url"
                    :to="item.url"
                  >
                    {{ item.title }}
                  </router-link>

                  <p v-else>
                    {{ item.title }}
                  </p>
                </div>

                <div class="footer-menu__list">
                  <router-link
                    v-for="subItem in item.subList"
                    :key="subItem.homeLinkName"
                    :to="subItem.homeLinkUrl"
                  >
                    {{ subItem.homeLinkName }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer__bottom">
          <div class="footer-info">
            <p>EMAIL: chengjun.uni@gmail.com</p>
          </div>

          <div class="footer-copyright">
            <p>Copyright© 2024 成均學院 All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import GetHomelinks from '@/api/HomelinksApi';

export default {
  data() {
    return {
      menuList: [
        {
          // title: '新手指南',
          // url: '/novices',
          subList: [],
        },
      ],
    };
  },
  created() {
    this.initializeMenu();
    this.GetList();
  },
  methods: {
    initializeMenu() {
      this.menuList[0].subList = [
        {
          homeLinkName: this.$t('guide.footer.faq'),
          homeLinkUrl: '/novices/question',
        },
        {
          homeLinkName: this.$t('guide.footer.about'),
          homeLinkUrl: '/novices/about',
        },
        {
          homeLinkName: this.$t('guide.footer.contact'),
          homeLinkUrl: '/novices/contact',
        },
        {
          homeLinkName: this.$t('guide.footer.policy'),
          homeLinkUrl: '/novices/policy',
        },
      ];
    },
    GetList() {
      GetHomelinks().then((response) => {
        if (response.data.statusCode === 0) {
          const target = this._.find(this.menuList, ['title', '相關連結']);

          if (target?.subList) {
            target.subList = this._.cloneDeep(response.data.data);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;

  font-size: 15px;
  line-height: 1.2;
  color: #98A2B3;

  background-color: #101828;

  .container {
    @media (min-width: 768px) {
      max-width: calc(var(--container-l-width) + (var(--container-padding) * 2));
    }
  }

  &-main {
    padding: 20px 0;

    @media (min-width: 768px) {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      align-content: flex-start;
    }

    &__left {
      @media (max-width: 767px) {
        display: flex;
        justify-content: center;

        width: 100%;
      }
    }

    &__right {
      @media (min-width: 768px) {
        display: flex;
      }

      @media (max-width: 767px) {
        width: 100%;
        margin-top: 20px;
      }
    }

    &__logo {
      img {
        height: 120px;

        @media (max-width: 991px) {
          height: 80px;
        }
      }
    }
  }

  &-menu {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    @media (max-width: 767px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    &__box {
      &:nth-child(n + 2) {
        margin: 0 0 0 15px;

        @media (max-width: 767px) {
          margin: 10px 0 0;
        }
      }
    }

    &__title {
      font-size: 17px;
      font-weight: 700;
      color: #fff;

      a {
        &:hover {
          opacity: .8;
        }
      }
    }

    &__title + &__list {
      margin-top: 10px;
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: flex-end;

      @media (max-width: 767px) {
        justify-content: flex-start;
      }

      width: 100%;

      a {
        display: block;

        &:nth-child(n + 2) {
          margin-left: 8px;

          @media (max-width: 767px) {
            margin: 0 0 0 8px;
          }
        }

        &:hover {
          color: var(--second-color);
        }
      }
    }
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    padding: 15px 0;

    border-top: 1px solid rgba(#fff, .2);

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;

      font-size: 13px;
      text-align: center;
    }
  }

  &-copyright, &-info {
    p {
      font-size: 13px;
      line-height: 1.5;
    }

    &:nth-child(2) {
      @media (max-width: 767px) {
        margin-top: 10px;
      }
    }
  }

  &-social {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    margin-right: 30px;

    @media (max-width: 767px) {
      margin: 0 0 20px;

      justify-content: center;
    }

    &__item {
      img {
        width: 30px;

        @media (max-width: 767px) {
          width: 24px;
        }
      }

      &:hover {
        opacity: .8;
      }

      &:nth-child(n + 2) {
        margin-left: 10px;
      }
    }
  }
}
</style>
